/**
 * Created by wangyongsheng on 17/4/9.
 * Modified by Ding on 17/4/12.
 */

import React, { Component, PropTypes } from 'react';
import { message, Modal } from 'antd';
import hash from 'hash.js';

import ResetPasswordForm from './ResetPasswordForm';
import { ajaxPost } from '../../utils/ajax';


export default class ResetPassword extends Component {

    static propTypes = {
        history: PropTypes.object.isRequired,
    };

    resetPassword = (params, callback) => {
        const newParams = Object.assign({}, params);
        newParams.password = hash.sha256().update(params.password).digest('hex');
        ajaxPost('/api/hunter/reset', newParams, () => {
            callback && callback(); // eslint-disable-line
            message.success('修改密码成功，请登录！', 1, () => this.props.history.push('/login'));
        }, (data) => {
            if (!data.meta || !data.meta.message) {
                message.error('修改失败！');
            } else {
                message.error(data.meta.message);
            }
            callback && callback(); // eslint-disable-line
        });
    };

    render() {
        return (
            <div>
                <Modal
                    title={<p style={{ fontSize: '18px', textAlign: 'center' }}>找回密码</p>}
                    visible
                    maskClosable={false}
                    closable={false}
                    footer={null}
                    className="hunter-login-modal"
                    width={500}
                >
                    <div style={{ padding: '40px 55px 0 0' }}>
                        <ResetPasswordForm handleSubmit={this.resetPassword} />
                    </div>
                </Modal>
            </div>
        );
    }
}

// TODO: remember, sign in
